import type { ThemeMode } from '../models/theme.model';

export const THEME_STORAGE_KEY = 'kasboek-theme';

export const THEME_LABEL: Readonly<Record<ThemeMode, string>> = {
  light: 'Ganti ke tema gelap',
  dark: 'Ganti ke tema terang',
};
